"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodes = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'school-analytics-service';
exports.errorCodes = Object.freeze({
    SCHOOL_NOT_FOUND: 'SCHOOL_NOT_FOUND',
    SCHOOL_SYNC_EXPIRED: 'SCHOOL_SYNC_EXPIRED'
});
//# sourceMappingURL=index.js.map